// ** Redux Imports
import { combineReducers } from 'redux'

// ** Reducers Imports
import auth from './auth'
import navbar from './navbar'
import layout from './layout'
import driverStatusReducer from './quickMenu'

const rootReducer = combineReducers({
  auth,
  navbar,
  layout,
  driverStatusReducer
})

export default rootReducer
